import Vue from "vue";
import {
    PUT_BABY_DRIVER,
} from "./types";

export default {
    [PUT_BABY_DRIVER]: (state, babyDriver) => {
        Vue.set(state, 'babyDriver', babyDriver);
    },
};